module.exports = __webpack_public_path__ + "img/placeholder.1dc48ded.png";